import Backbone from '@rover/globals/backbone';
import $ from '@rover/globals/jquery';
import _ from '@rover/globals/underscore';

import OptionalRequesterAddOnView from './optional_requester_addon_view';

export default Backbone.View.extend({
  initialize(options) {
    _.bindAll(this, 'render');
    this.requestableModel = options.requestableModel;
    this.listenTo(this.requestableModel, 'complete', this.render);
    this.listenTo(this.requestableModel, 'change:requester_add_ons', this.render);
  },
  render() {
    const self = this;
    self.$el.hide();
    self.$el.empty();
    _.each(self.requestableModel.getOptionalRequesterAddOns(), (addOn) => {
      // Do not display the "Ask A Vet" add on container to
      // an Owner during a Conversation checkout step
      if (addOn.slug !== 'ask-a-vet') {
        const addOnContainer = $(`<div class="js-requester-add-on-${addOn.slug}-container"></div>`);
        self.$el.append(addOnContainer);

        const addOnView = new OptionalRequesterAddOnView({
          addOn,
          requestableModel: self.requestableModel,
          el: addOnContainer,
        });
        addOnView.render();
      }
    });
    self.$el.show();
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/checkout/optional_requester_addons_list_view.js